import { MoneyIcon } from 'tdesign-icons-vue-next';
import { shallowRef } from 'vue';
import { RouteRecordRaw } from 'vue-router';

export default [
  {
    path: '/financial-management',
    name: 'financialManagement',
    redirect: '/financial-management/remit-record',
    component: () => import('@/layouts/index.vue'),
    meta: {
      title: '财务管理',
      icon: shallowRef(MoneyIcon),
      permission: ['PaymentRecordList', 'DeductionRecordList', 'AgentAccountList'],
    },
    children: [
      {
        path: 'remit-record',
        name: 'remitRecord',
        component: () => import('@/pages/financial-management/remit-record.vue'),
        meta: {
          title: '代理商打款记录',
          permission: ['PaymentRecordList'],
        },
      },
      {
        path: 'deduction-record',
        name: 'deductionRecord',
        component: () => import('@/pages/financial-management/deduction-record.vue'),
        meta: {
          title: '代理商扣款记录',
          permission: ['DeductionRecordList'],
        },
      },
      {
        path: 'balance-sum',
        name: 'balanceSum',
        component: () => import('@/pages/financial-management/balance-sum.vue'),
        meta: {
          title: '代理商余额汇总',
          permission: ['AgentAccountList'],
        },
      },
    ],
  },
] as RouteRecordRaw[];
